
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    // get list
    var reviewList = $('.don-customervoice');

    function setSameHeight() {
        var $body = $('body');
        var isSm = $body.hasClass('is-sm');

        reviewList.each(function () {

            // init vars
            var $reviews = $(this).find('.don-customervoice__box');
            var maxHeight = 0;

            // clear height styles and find max heights
            $reviews.each(function () {
                var $review = $(this);

                $review.removeAttr('style');

                maxHeight = $review.height() > maxHeight ? $review.height() : maxHeight;
            });

            // skip if xs
            if (!isSm) {
                return;
            }

            // set max heights
            $reviews.each(function () {
                $teaser = $(this);

                $teaser.height(maxHeight);
            });
        });
    }

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setSameHeight();
        }, 200);
    });

    $(document).ready(setSameHeight);
})(window, document, jQuery);
